import { cn } from "@newxsystems/shared";
import type { IStratosRichTextProps } from "./StratosRichText.props";

export const StratosRichText = ({ className, content }: IStratosRichTextProps) => (
  <div
    className={cn(
      "font-stratos-body  text-lg leading-[1.35] text-pretty text-foreground md:text-xl [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:border-l [&_blockquote]:border-horizon-blue [&_blockquote]:pl-6 [&_blockquote]:text-steel [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-5 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

StratosRichText.displayName = "Content::StratosRichText";
